import React from 'react';
import { Link } from 'react-router-dom';
import { extractPlainText } from '../../utils/richTextRenderer';
import { getImageUrl } from '../../services/api';

const RelatedProducts = ({ products, currentProductId }) => {
  if (!products || products.length === 0) {
    return null;
  }

  // Filter out current product and limit to 3 related products
  const relatedProducts = products
    .filter(product => product.id !== currentProductId)
    .slice(0, 3);

  if (relatedProducts.length === 0) {
    return null;
  }

  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-catalina-blue mb-4">
            Related Products
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Explore more products from the same category
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {relatedProducts.map((product) => {
            const imageUrl = product.Image ? getImageUrl(product.Image, 'medium') : null;
            
            return (
              <Link
                key={product.id}
                to={`/product/${product.slug}`}
                className="bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm hover:shadow-lg transition-all duration-300 group"
              >
                {/* Product Image */}
                <div className="relative w-full h-64 bg-gray-100 overflow-hidden">
                  {imageUrl ? (
                    <img 
                      src={imageUrl} 
                      alt={product.Image?.alternativeText || product.Title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <svg className="w-20 h-20 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </div>
                  )}
                  
                  {/* Featured Badge */}
                  {product.featured && (
                    <div className="absolute top-4 right-4 bg-yellow-400 text-gray-900 px-3 py-1 rounded-full text-xs font-bold">
                      Featured
                    </div>
                  )}
                </div>
                
                {/* Product Content */}
                <div className="p-6">
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-catalina-blue transition duration-300">
                    {product.Title}
                  </h3>
                  
                  {product.Description && (
                    <p className="text-gray-600 mb-4 leading-relaxed line-clamp-2">
                      {extractPlainText(product.Description, 80)}
                    </p>
                  )}
                  
                  <span className="inline-flex items-center text-catalina-blue font-semibold group-hover:text-san-marino transition duration-300">
                    View Details
                    <svg className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default RelatedProducts;